import { defineMessages } from 'react-intl-next';

export const i18n: {
	descriptionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	imageLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titlePlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	titleLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-title-label',
		defaultMessage: 'Title',
		description: 'Label for title input for configuring Spotlight extension',
	},
	descriptionLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-description-label',
		defaultMessage: 'Description',
		description: 'Label for description input for configuring Spotlight extension',
	},
	imageLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-image-label',
		defaultMessage: 'Image',
		description:
			'Label for image button that opens a popup for media picker for configuring Spotlight extension',
	},
	titlePlaceholder: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder',
		defaultMessage: 'Give your spotlight a title',
		description: 'Input placeholder text for configuring Spotlight extension title',
	},
	descriptionPlaceholder: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder',
		defaultMessage:
			'Spotlights highlight important messages for your team. Design your spotlight with an image, your custom colors, a short description, and a link.',
		description: 'Input placeholder text for configuring Spotlight extension description',
	},
});
